import { CallAPI } from "../../apiManager/ApiCall";
import { usmlePrepURL } from "../../apiManager/APIConfig";

export const GetUsmleCatalogCall = async () => {
  try {
    return await CallAPI({ url: `${usmlePrepURL}/catalog`, method: "GET" });
  } catch {
    return { status: 400, message: "Failed to load USMLE catalog" };
  }
};

export const GetUsmleQuestionsCall = async (params = {}) => {
  try {
    const qs = new URLSearchParams();
    if (params.step) qs.set("step", params.step);
    if (params.subject) qs.set("subject", params.subject);
    const q = qs.toString();
    return await CallAPI({
      url: `${usmlePrepURL}/questions${q ? `?${q}` : ""}`,
      method: "GET",
    });
  } catch {
    return { status: 400, message: "Failed to load questions" };
  }
};

export const CreateUsmleQuestionCall = async (body) => {
  try {
    return await CallAPI({
      url: `${usmlePrepURL}/questions`,
      method: "POST",
      body,
    });
  } catch {
    return { status: 400, message: "Failed to create question" };
  }
};

export const UpdateUsmleQuestionCall = async (id, body) => {
  try {
    return await CallAPI({
      url: `${usmlePrepURL}/questions/${id}`,
      method: "PUT",
      body,
    });
  } catch {
    return { status: 400, message: "Failed to update question" };
  }
};

export const DeleteUsmleQuestionCall = async (id) => {
  try {
    return await CallAPI({
      url: `${usmlePrepURL}/questions/${id}`,
      method: "DELETE",
    });
  } catch {
    return { status: 400, message: "Failed to delete question" };
  }
};

export const GenerateUsmleQuestionsCall = async (body) => {
  try {
    return await CallAPI({
      url: `${usmlePrepURL}/generate`,
      method: "POST",
      body,
    });
  } catch {
    return { status: 400, message: "Failed to generate questions" };
  }
};

export const SaveGeneratedUsmleQuestionsCall = async (questions) => {
  try {
    return await CallAPI({
      url: `${usmlePrepURL}/generate/save`,
      method: "POST",
      body: { questions },
    });
  } catch {
    return { status: 400, message: "Failed to save generated questions" };
  }
};
